import { render, staticRenderFns } from "./LeaveSettingsTypeDetails.vue?vue&type=template&id=2023bb48&"
import script from "./LeaveSettingsTypeDetails.vue?vue&type=script&lang=js&"
export * from "./LeaveSettingsTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeaveSettingsTypeDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports